import React, {Component, Fragment} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from 'material-ui/Paper';
import AppBar from 'material-ui/AppBar';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Subheader from 'material-ui/Subheader';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSave from 'material-ui/svg-icons/content/save';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Divider from 'material-ui/Divider';
import Snackbar from 'material-ui/Snackbar';
import {Tabs, Tab} from 'material-ui/Tabs';
import SessionCourse from './SessionCourse'
import Header from './Header'
import Progress from './CircularProgress'
import {Link} from 'react-router-dom'

import * as firebase from 'firebase'

import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
} from 'material-ui/Table';

import {
    AllAboutHunting, ATVRiderCourse, BasicFishingSkills, BoatingTrailering, Geocaching,
    HerpingArkansas, IntroScuba, OutdoorPhotography, OutdoorSurvivalSkills, BasicCampingSkills,
    Kayaking, WOTWS, BasicFlyCasting, BasicTrapping, Birding, DeerHunting101, DutchOvenCooking,
    NatureCrafts, RifleMarkswomanship, ShotgunBasics, AllAboutHummingBirds, BasicArcherSkills,
    BackyardHabitats, BasicFlyTying, FromFieldToFreezer, BasicFlyFishing, BasicPistolClass, FurHandling,
    IntroToArcheryHunting, Hiking101,  TurkeyWaterfowlHunting101

} from './course'




const style = {
    marginLeft: 20,
    paddingRight: 20,
    underlineStyle: {
        borderColor: "#009390",
    },
    floatingLabelStyle: {
        color: "#009390",
    },
    appBar: {
        textAlign: 'center',
        backgroundColor: "#009390"
    },
    selectedDropDownItem: {
        color: "#009390"
    },
    radioButtonGroup:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "center",
        marginTop:10,
        marginBlockStart:10,
    },
    radioButton: {
         maxWidth: 50,
    }
};

const formFieldError = "Error: Field is Empty"

const uuidv4 = require('uuid/v4');


/**
 * Statefull Component Class for BOW Registration form
 */
class RegistrationForm extends Component {


    /**
     * Set inital state of applicaiton using constructor
     */
    constructor(props) {
        super(props);
        this.state = {

            // Form State
            firstName: "",
            middleName: "",
            lastName: "",
            email: "",
            confirmEmail: "",
            addressOne: "",
            addressTwo: "",
            city: "",
            homeState: "",
            zipCode: undefined,
            shirtSize: "",
            phoneDay: "",
            phoneNight: "",
            attendedWorkShopCount: "",
            roomMateOne: "",
            roomMateTwo: "",
            dietaryNeeds: "",
            open: false,
            isConfirmation: false,
            isSnacker: false,
            isSubmitting: false,
            submissionError: false,

            // Session I state 
            isSession_I : false,
            sessionI_AllAboutHunting: "",
            sessionI_BasicFishing: "",
            sessionI_WOTWS: "",
            sessionI_ATVRiderCourse: "",
            sessionI_BoatingTrailering: "",
            sessionI_BasicCampingSkills: "",
            sessionI_Geocaching: "",
            sessionI_Herping: "",
            sessionI_Scuba: "",
            sessionI_Kayaking: "",
            sessionI_Photography: "",
            sessionI_OutdoorSurvivalSkills: "",

            // Session II state
            isSession_II :  false,
            sessionII_BasicFishing: "",
            sessionII_BasicFlyCasting: "",
            sessionII_BasicTrapping: "",
            sessionII_Birding: "",
            sessionII_DeerHunting101: "",
            sessionII_DutchOvenCooking: "",
            sessionII_Kayaking: "",
            sessionII_NatureCrafts: "",
            sessionII_RifleMarksmanship: "",
            sessionII_ShotgunBasics: "",

            // Session III state
            isSession_III :  false,
            sessionIII_AllAboutHummingBirds: "",
            sessionIII_BasicArcherySkills: "",
            sessionIII_BackyardHabitats: "",
            sessionIII_BasicFlyTying: "",
            sessionIII_BasicTrapping: "",
            sessionIII_FromFieldToFreezer: "",
            sessionIII_HerpingArkansas: "",
            sessionIII_OutdoorSurvivalSkills: "",
            sessionIII_RifleMarksWomanship: "",
            sessionIII_ShotgunBasics: "",


            // Session IV state
            isSession_IV :  false,
            sessionIV_AdvancedDutchOvenCooking: "",
            sessionIV_AllAboutHummingbirds: "",
            sessionIV_BackyardHabitats: "",
            sessionIV_BasicFlyFishing: "",
            sessionIV_BasicPistolClass: "",
            sessionIV_Birding: "",
            sessionIV_FurHandling: "",
            sessionIV_IntroToArcheryHunting: "",
            sessionIV_Hiking101: "",
            sessionIV_TurkeyWaterfowlHunting101: "",
        };

    }

    /**
     * Opens Modal by setting state
     */
    handleOpen = () => {
        this.setState({open: true});
    };

    /**
     * Closes Modal VIA state
     */
    handleClose = () => {
        this.setState({open: false});
    };

    

    /**
     * Validate that all required fields are filled out before you can submit
     */
    validateInput = () => {
        const {email, firstName, lastName, phoneDay, phoneNight, confirmEmail, addressOne, city, homeState, 
                zipCode, shirtSize, attendedWorkShopCount, isSession_I, isSession_II, isSession_III, isSession_IV} = this.state;
        const emailValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        let errors = true;
        let message = "";
        email.toLowerCase() === confirmEmail.toLowerCase()
            ? (firstName && !(/^(\s+)$/i.test(firstName)))
            ? (lastName && !(/^(\s+)$/i.test(lastName)))
                ? (addressOne && !(/^(\s+)$/i.test(addressOne)))
                        ? (city && !(/^(\s+)$/i.test(city)))
                            ? (homeState && !(/^(\s+)$/i.test(homeState)))
                                ? (zipCode && !(/^(\s+)$/i.test(zipCode)) && /^[0-9]+$/i.test(zipCode))
                                    ? ((phoneDay && /^[1-9]\d{2}-\d{3}-\d{4}$/i.test(phoneDay)) || (phoneNight && /^[1-9]\d{2}-\d{3}-\d{4}$/i.test(phoneNight)))
                                        ? emailValid
                                            ? shirtSize
                                                ? attendedWorkShopCount
                                                        ? isSession_I
                                                            ? isSession_II
                                                                ? isSession_III
                                                                    ? isSession_IV
                                                                        ? errors = false
                                                                    : message = "Session IV ranking is required"
                                                                : message = "Session III ranking is required"
                                                            : message = "Session II ranking is required"
                                                        : message = "Session I ranking is required"
                                                    : message = "Past Work Shops is required"
                                                : message = "T-Shirt Size is required"
                                            : message = "Email is not valid"
                                        : message = "Phone (Day) OR Phone (Night) is required"
                                    : message = "Zip Code is required"
                                : message = "State is required"
                            : message = "City is required"
                    : message = "Address 1 is required"
                : message = "Last Name is required"
            : message = "First Name is required"
            : message = "Emails do not match";
        return errors ? message : errors;
    }

   
    /**
     * Opens Snacker after submission
     */
    handleSnackerOpen = () => {
        this.setState({
            isSnacker: true,
        });
    };

    /**
     * Closses Snacker
     */
    handleSnackerClose = () => {
        this.setState({
            isSnacker: false,
        });
    };

    handleFinishedForm = () => {
        this.setState({
            isConfirmation: true,
        });
    };


    handleSubmitErrorOpen = () => {
        this.setState({
            submissionError: true
        })
    }

    handleSubmitErrorClose = () => {
        this.setState({
            submissionError: false
        })
    }


  

    /**
     * Submits form data using application state
     */
    handleSubmit = (event) => {

        event.preventDefault();

        const dt = new Date();
        const time = dt.toLocaleTimeString()
        const date = dt.toLocaleDateString()
    
        this.setState({isSubmitting: true})


          firebase.database().ref('FormID'+ uuidv4()).set({
            "First Name": this.state.firstName,
            "Middle Name": this.state.middleName,
            "Last Name": this.state.lastName,
            "Address 1": this.state.addressOne,
            "Address 2": this.state.addressTwo,
            "City": this.state.city,
            "State": this.state.homeState,
            "Zip Code": this.state.zipCode,
            "Phone Day": this.state.phoneDay,
            "Phone Night": this.state.phoneNight,
            "Email": this.state.email,
            "T-Shirt Size": this.state.shirtSize,
            "Work Shops Attended": this.state.attendedWorkShopCount,
            "Friend One": this.state.roomMateOne,
            "Friend Two": this.state.roomMateTwo,
            "Dietary Needs": this.state.dietaryNeeds,
            "Time Stamp": `${date} : ${time}`,
            "Session I": {
                "All About Hunting For the Beginner": this.state.sessionI_AllAboutHunting,
                "Basic Fishing": this.state.sessionI_BasicFishing,
                "A Walk on the Wild Side: Edible Trees and Plants": this.state.sessionI_WOTWS,
                "ATV Rider Course": this.state.sessionI_ATVRiderCourse,
                "Boating Trailering": this.state.sessionI_BoatingTrailering,
                "Basic Camping Skills": this.state.sessionI_BasicCampingSkills,
                "Geocaching": this.state.sessionI_Geocaching,
                "Herping in Arkansas ": this.state.sessionI_Herping,
                "Intro to SCUBA": this.state.sessionI_Scuba,
                "Kayaking": this.state.sessionI_Kayaking,
                "Outdoor Photography": this.state.sessionI_Photography,
                "Outdoor Survival Skills": this.state.sessionI_OutdoorSurvivalSkills,
            },
            "Session II":{
                "Basic Fishing": this.state.sessionII_BasicFishing,
                "Basic Fly casting": this.state.sessionII_BasicFlyCasting,
                "Basic Trapping": this.state.sessionII_BasicTrapping,
                "Birding": this.state.sessionII_Birding, 
                "Deer Hunting ": this.state.sessionII_DeerHunting101,
                "Dutch Oven Cooking": this.state.sessionII_DutchOvenCooking,
                "Kayaking": this.state.sessionII_Kayaking,
                "Nature Crafts": this.state.sessionII_NatureCrafts, 
                "Rifle Markswomanship": this.state.sessionII_RifleMarksmanship,
                "Shotgun Basics": this.state.sessionII_ShotgunBasics,
            },
            "Session III":{
                "All About Humming Birds": this.state.sessionIII_AllAboutHummingBirds,
                "Basic Archery Skills": this.state.sessionIII_BasicArcherySkills,
                "Backyard Habitats": this.state.sessionIII_BackyardHabitats,
                "Basic Fly Tying": this.state.sessionIII_BasicFlyTying,
                "Basic Trapping": this.state.sessionIII_BasicTrapping, 
                "From Field To Freezer": this.state.sessionIII_FromFieldToFreezer,
                "Herping in Arkansas": this.state.sessionIII_HerpingArkansas,
                "Outdoor Survival Skills": this.state.sessionIII_OutdoorSurvivalSkills,
                "Rifle MarksWomanship": this.state.sessionIII_RifleMarksWomanship,
                "Shotgun Basics": this.state.sessionIII_ShotgunBasics,
            },
            "Session IV":{
               "Advanced Dutch Oven Cooking": this.state.sessionIV_AdvancedDutchOvenCooking,
                "All About Hummingbirds": this.state.sessionIV_AllAboutHummingbirds,
                "Backyard Habitats": this.state.sessionIV_BackyardHabitats,
                "Basic Fly fishing": this.state.sessionIV_BasicFlyFishing,
                "Basic Pistol Class": this.state.sessionIV_BasicPistolClass,
                "Birding": this.state.sessionIV_Birding,
                "Fur Handling": this.state.sessionIV_FurHandling,
                "Intro to Archery Hunting": this.state.sessionIV_IntroToArcheryHunting,
                "Hiking 101": this.state.sessionIV_Hiking101,
                "Turkey Waterfowl Hunting ": this.state.sessionIV_TurkeyWaterfowlHunting101
            }
          
        }).then(() => {
            console.log( "Shawn Firebase DB was successful:");
            this.handleClose();
        })
        .then(() => {
            this.setState({isSubmitting: false})
            this.handleFinishedForm();
          })
        .catch((error) => {
            console.log( "Shawn Firebase DB Failed:", error);
            this.handleClose();
            this.setState({isSubmitting: false})
            this.handleSubmitErrorOpen()
          }); 
    }


    componentDidMount(){
       
    }

render() {

    const errors = this.validateInput();
    const shirtItems = [
        <MenuItem key={1} value={"Small"} primaryText="Small"/>,
        <MenuItem key={2} value={"Medium"} primaryText="Medium"/>,
        <MenuItem key={3} value={"Large"} primaryText="Large"/>,
        <MenuItem key={4} value={"X-Large"} primaryText="X-Large"/>,
        <MenuItem key={5} value={"XX-Large"} primaryText="XX-Large"/>,
        <MenuItem key={6} value={"XXX-Large"} primaryText="XXX-Large"/>,
    ];
    const workShopItems = [
        <MenuItem key={0} value={"0"} primaryText="0"/>,
        <MenuItem key={1} value={"1"} primaryText="1"/>,
        <MenuItem key={2} value={"2"} primaryText="2"/>,
        <MenuItem key={3} value={"3"} primaryText="3"/>,
        <MenuItem key={4} value={"4"} primaryText="4"/>,
        <MenuItem key={5} value={"5+"} primaryText="5+"/>,
    ];
    const confirmationList = [

            {
                label:"First Name",
                value: this.state.firstName
            },
            {
                label:"Middle Name",
                value: this.state.middleName
            },
            {
                label:"Last Name",
                value: this.state.lastName
            },
            {
                label:"Address One",
                value: this.state.addressOne
            },
            {
                label:"Address Two",
                value: this.state.addressTwo
            },
            {
                label:"City",
                value: this.state.city
            },
            {
                label:"State",
                value: this.state.homeState
            },
            {
                label:"Zip Code",
                value: this.state.zipCode
            },
            {
                label:"Phone (Day)",
                value: this.state.phoneDay
            },
            {
                label:"Phone (Night)",
                value: this.state.phoneNight
            },
            {
                label:"Email",
                value: this.state.email
            },
            {
                label:"Selected Shirt Size",
                value: this.state.shirtSize
            },
            {
                label:"Past Work Shops Attended",
                value: this.state.attendedWorkShopCount
            },
            {
                label:"First Friend",
                value: this.state.roomMateOne
            },
            {
                label:"Second Friend",
                value: this.state.roomMateTwo
            },
            {
                label:"Dietary Needs",
                value: this.state.dietaryNeeds
            },  
    ]



    const actions = [
    <FlatButton
        label="Cancel"
        onClick={this.handleClose}

    />,
    <FlatButton
        label="Submit"
        primary={true}
        style={{color: "#009390"}}
        onClick={this.handleSubmit}
    />,
    ];

    const confirmation = <Dialog
                            title={this.state.isSubmitting? "Submiting Reservation" :"Review Reservation"}
                            actions={actions}
                            modal={true}
                            autoScrollBodyContent={true}
                            open={this.state.open}
                        >
                            {this.state.isSubmitting ? <Progress
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: 0,
                                                                    right: 0,
                                                                    bottom: 0,
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center'
                                                                }}/>: null}
                            {
                            confirmationList.map((l, i) =>(
                                <div key={i}>
                                <Subheader  inset={true}>{l.label}</Subheader>
                                {l.value}
                                <Divider/>
                                </div>
                                
                            ))
                            }
                        </Dialog>




const successActions = [
    <Link className="btn btn-success btn-lg" to="/"  role="button">Finished</Link>
    ,
    ];

const formSubmissionSuccess = <Dialog
                                title={"Congratulations your registration has been submitted!"}
                                actions={successActions}
                                modal={true}
                                autoScrollBodyContent={true}
                                open={this.state.isConfirmation}>

                                <div className="alert alert-primary" role="alert">Registration will continue until June 30. Selections will begin in July.</div>
                                <img src={require('../assets/bow_logo.png')}  alt="Outdoors-Woman" style={{bottom:5, left:5}}/>
                            </Dialog>


const submitErrorActions = [
    <button className="btn btn-danger btn-lg" onClick={this.handleSubmitErrorClose}> Exit </button>
    ];

    const submitError =  <Dialog
                            title={"Submission Error!"}
                            actions={submitErrorActions}
                            modal={true}
                            autoScrollBodyContent={true}
                            open={this.state.submissionError}>
    
                                <div className="alert alert-danger" role="alert">
                                Registration form did not submit. Please try again later.
                                </div>
        
                        </Dialog>


                           

    const SessionICourseList = [
        {
            Title:  "All About Hunting - For the Beginner",
            Details: AllAboutHunting,
            Instructor: "Joe Huggins/Aimee Swaim",
            ButtonGroupName: "Session I All About Hunting",
            onChangeCourse: (value) => this.setState({sessionI_AllAboutHunting: value, isSession_I: true})
        },
        {
            Title:  "Basic Fishing",
            Details: BasicFishingSkills,
            Instructor: "Lea Gray/Bo Davidson",
            ButtonGroupName: "Session I Basic Fishing",
            onChangeCourse: (value) => this.setState({sessionI_BasicFishing: value, isSession_I: true})
        },
        {
            Title:  "A Walk on the Wild Side: Edible Trees and Plants (start at 1:00)",
            Details: WOTWS,
            Instructor: "Tamara Walkingstick",
            ButtonGroupName: "WOTWS",
            onChangeCourse: (value) => this.setState({sessionI_WOTWS: value, isSession_I: true})
        },
        {
            Title: "ATV Rider Course",
            Details: ATVRiderCourse,
            Instructor: "Sydney Grant/Jessica McBride",
            ButtonGroupName: "ATV Rider Course",
            onChangeCourse: (value) => this.setState({sessionI_ATVRiderCourse: value, isSession_I: true})
        },
        {
            Title: "Boating/Trailering (start at 1:00)",
            Details: BoatingTrailering,
            Instructor: "Corps of Engineers/ AGFC Officers",
            ButtonGroupName: "Boating/Trailering",
            onChangeCourse: (value) => this.setState({sessionI_BoatingTrailering: value, isSession_I: true})
        }, 
        {
            Title: "Basic Camping Skills",
            Details: BasicCampingSkills,
            Instructor: "Shannon Caldwell",
            ButtonGroupName: "Basic Camping",
            onChangeCourse: (value) => this.setState({sessionI_BasicCampingSkills: value, isSession_I: true})
        }, 
        {
            Title: "Geocaching",
            Details: Geocaching,
            Instructor: "Eric DeVries",
            ButtonGroupName: "Geocaching",
            onChangeCourse: (value) => this.setState({sessionI_Geocaching: value, isSession_I: true})
        }, 
        {
            Title: "Herping in Arkansas  (class + 8pm Herping)",
            Details: HerpingArkansas,
            Instructor: "Lori Monday",
            ButtonGroupName: "Herping",
            onChangeCourse: (value) => this.setState({sessionI_Herping: value, isSession_I: true})
        },
        {
            Title: "Intro to SCUBA",
            Details: IntroScuba,
            Instructor: "Kirsten Bartlow/ Ocean Extreme",
            ButtonGroupName: "IntroScuba",
            onChangeCourse: (value) => this.setState({sessionI_Scuba: value, isSession_I: true})
        }, 
        {
            Title: "Kayaking",
            Details: Kayaking,
            Instructor: "Kelly Farrel/ Kayla Gomance/Julie Lovett",
            ButtonGroupName: "Kayaking",
            onChangeCourse: (value) => this.setState({sessionI_Kayaking: value, isSession_I: true})
        }, 
        {
            Title: "Outdoor Photography",
            Details: OutdoorPhotography,
            Instructor: "Mike Wintroath",
            ButtonGroupName: "OutdoorPhotography",
            onChangeCourse: (value) => this.setState({sessionI_Photography: value, isSession_I: true})
        }, 
        {
            Title: "Outdoor Survival Skills",
            Details: OutdoorSurvivalSkills,
            Instructor: "Doug Newcomb/Laura Rogers",
            ButtonGroupName: "OutdoorSurvivalSkill",
            onChangeCourse: (value) => this.setState({sessionI_OutdoorSurvivalSkills: value, isSession_I: true})
        },      
    ]
            
    const SessionIICourseList = [
        {
            Title:  "Basic Fishing",
            Details: BasicFishingSkills,
            Instructor: "Lea Gray/Bo Davidson",
            ButtonGroupName: "Session II Basic Fishing",
            onChangeCourse: (value) => this.setState({sessionII_BasicFishing: value, isSession_II: true})
        },
        {
            Title:  "Basic Fly-casting",
            Details: BasicFlyCasting,
            Instructor: "Denis Dunderdale",
            ButtonGroupName: "Session II Basic Fly-casting",
            onChangeCourse: (value) => this.setState({sessionII_BasicFlyCasting: value, isSession_II: true})
        },
        {
            Title:  "Basic Trapping",
            Details: BasicTrapping,
            Instructor: "Mike FIscher/Jason Hooks",
            ButtonGroupName: "Session II Basic Trapping",
            onChangeCourse: (value) => this.setState({sessionII_BasicTrapping: value, isSession_II: true})
        },
        {
            Title:  "Birding (start at 7:00)",
            Details: Birding,
            Instructor: "Uta Meyer",
            ButtonGroupName: "Session II Birding",
            onChangeCourse: (value) => this.setState({sessionII_Birding: value, isSession_II: true})
        },
        {
            Title:  "Deer Hunting 101",
            Details: DeerHunting101,
            Instructor: "Chad Lowe",
            ButtonGroupName: "Session II Deer Hunting 101",
            onChangeCourse: (value) => this.setState({sessionII_DeerHunting101: value, isSession_II: true})
        },
        {
            Title:  "Dutch Oven Cooking",
            Details: DutchOvenCooking,
            Instructor: "Hollie Sanders/ Tracy Moy/ Sheila Connerly",
            ButtonGroupName: "Session II Dutch Oven Cooking",
            onChangeCourse: (value) => this.setState({sessionII_DutchOvenCooking: value, isSession_II: true})
        },
        {
            Title:  "Kayaking",
            Details: Kayaking,
            Instructor: "Kelly Farrel/ Kayla Gomance/Julie Lovett",
            ButtonGroupName: "Session II Kayaking",
            onChangeCourse: (value) => this.setState({sessionII_Kayaking: value, isSession_II: true})
        },
        {
            Title:  "Nature Crafts",
            Details: NatureCrafts,
            Instructor: "Lee Elkins",
            ButtonGroupName: "Session II Nature Crafts",
            onChangeCourse: (value) => this.setState({sessionII_NatureCrafts: value, isSession_II: true})
        },
        {
            Title:  "Rifle Markswomanship",
            Details: RifleMarkswomanship,
            Instructor: "Bill Haynes/Eric Maynard",
            ButtonGroupName: "Session II Rifle Markswomanship",
            onChangeCourse: (value) => this.setState({sessionII_RifleMarksmanship: value, isSession_II: true})
        },
        {
            Title:  "Shotgun Basics",
            Details: ShotgunBasics,
            Instructor: "Chuck Long/Steve Dunlap",
            ButtonGroupName: "Session II Shotgun Basics",
            onChangeCourse: (value) => this.setState({sessionII_ShotgunBasics: value, isSession_II: true})
        },
    
    ]


    const SessionIIICourseList = [
        {
            Title:  "All About Hummingbirds",
            Details: AllAboutHummingBirds,
            Instructor: "Tana Beasley",
            ButtonGroupName: "Session III All About Hummingbirds",
            onChangeCourse: (value) => this.setState({sessionIII_AllAboutHummingBirds: value, isSession_III: true})
        },
        {
            Title:  "Basic Archery Skills",
            Details: BasicArcherSkills,
            Instructor: "Curtis Gray",
            ButtonGroupName: "Session III Basic Archery Skills",
            onChangeCourse: (value) => this.setState({sessionIII_BasicArcherySkills: value, isSession_III: true})
        },
        {
            Title:  "Backyard Habitats",
            Details: BackyardHabitats,
            Instructor: "AJ Riggs/ Cindy Franklin",
            ButtonGroupName: "Session III Backyard Habitats",
            onChangeCourse: (value) => this.setState({sessionIII_BackyardHabitats: value, isSession_III: true})
        },
        {
            Title:  "Basic Fly-tying",
            Details: BasicFlyTying,
            Instructor: "Denis Dunderdale",
            ButtonGroupName: "Session III Basic Fly-tying",
            onChangeCourse: (value) => this.setState({sessionIII_BasicFlyTying: value, isSession_III: true})
        },
        {
            Title:  "Basic Trapping",
            Details: BasicTrapping,
            Instructor: "Mike FIscher/Jason Hooks",
            ButtonGroupName: "Session III  Basic Trapping",
            onChangeCourse: (value) => this.setState({sessionIII_BasicTrapping: value, isSession_III: true})
        },
        {
            Title:  "From Field To Freezer",
            Details: FromFieldToFreezer,
            Instructor: "Cody Walker/Chad Lowe",
            ButtonGroupName: "Session III  From Field To Freezer",
            onChangeCourse: (value) => this.setState({sessionIII_FromFieldToFreezer: value, isSession_III: true})
        },
        {
            Title:  "Herping in Arkansas  (class + 8pm Herping)",
            Details: HerpingArkansas,
            Instructor: "Lori Monday",
            ButtonGroupName: "Session III  Herping",
            onChangeCourse: (value) => this.setState({sessionIII_HerpingArkansas: value, isSession_III: true})
        },
        {
            Title:  "Outdoor Survival Skills",
            Details: OutdoorSurvivalSkills,
            Instructor: "Doug Newcomb/Laura Rogers",
            ButtonGroupName: "Session III OutdoorSurvivalSkill",
            onChangeCourse: (value) => this.setState({sessionIII_OutdoorSurvivalSkills: value, isSession_III: true})
        },
        {
            Title:  "Rifle Markswomanship",
            Details: RifleMarkswomanship,
            Instructor: "Bill Haynes/Eric Maynard",
            ButtonGroupName: "Session III Rifle Markswomanship",
            onChangeCourse: (value) => this.setState({sessionIII_RifleMarksWomanship: value, isSession_III: true})
        },
        {
            Title:  "Shotgun Basics",
            Details: ShotgunBasics,
            Instructor: "Chuck Long/Steve Dunlap",
            ButtonGroupName: "Session III Shotgun Basics",
            onChangeCourse: (value) => this.setState({sessionIII_ShotgunBasics: value, isSession_III: true})
        },
    ]

    const SessionIVCourseList = [
        {
            Title: "Advanced Dutch Oven Cooking",
            Details: DutchOvenCooking,
            Instructor: "Hollie Sanders/ Tracy Moy/ Sheila Connerly",
            ButtonGroupName: "Session IV Advanced Dutch Oven Cooking",
            onChangeCourse: (value) => this.setState({sessionIV_AdvancedDutchOvenCooking: value, isSession_IV: true})
        },
        {
            Title:  "All About Hummingbirds",
            Details: AllAboutHummingBirds,
            Instructor: "Tana Beasley",
            ButtonGroupName: "Session IV All About Hummingbirds",
            onChangeCourse: (value) => this.setState({sessionIV_AllAboutHummingbirds: value, isSession_IV: true})
        },
        {
            Title: "Backyard Habitats",
            Details: BackyardHabitats,
            Instructor: "AJ Riggs/ Cindy Franklin",
            ButtonGroupName: "Session IV Backyard Habitats",
            onChangeCourse: (value) => this.setState({sessionIV_BackyardHabitats: value, isSession_IV: true})
        },
        {
            Title: "Basic Fly-fishing",
            Details: BasicFlyFishing,
            Instructor: "Denis Dunderdale",
            ButtonGroupName: "Session IV Basic Fly-fishing",
            onChangeCourse: (value) => this.setState({sessionIV_BasicFlyFishing: value, isSession_IV: true})
        },
        {
            Title: "Basic Pistol Class",
            Details: BasicPistolClass,
            Instructor: "Bill Haynes/Eric Maynard",
            ButtonGroupName: "Session IV  Basic Pistol Class",
            onChangeCourse: (value) => this.setState({sessionIV_BasicPistolClass: value, isSession_IV: true})
        },
        {
            Title: "Birding (start at 7:00)",
            Details: Birding,
            Instructor: "Uta Meyer",
            ButtonGroupName: "Session IV Birding",
            onChangeCourse: (value) => this.setState({sessionIV_Birding: value, isSession_IV: true})
        },
        {
            Title: "Fur Handling",
            Details: FurHandling,
            Instructor: "Cody Walker",
            ButtonGroupName: "Session IV Fur Handling",
            onChangeCourse: (value) => this.setState({sessionIV_FurHandling: value, isSession_IV: true})
        },
        {
            Title: "Intro to Archery Hunting",
            Details: IntroToArcheryHunting,
            Instructor: "Curtis Gray",
            ButtonGroupName: "Session IV Intro to Archery Hunting",
            onChangeCourse: (value) => this.setState({sessionIV_IntroToArcheryHunting: value, isSession_IV: true})
        },
        {
            Title: "Hiking 101",
            Details: Hiking101,
            Instructor: "Lauren Marshall/Aimee Swaim",
            ButtonGroupName: "Session IV  Hiking 101",
            onChangeCourse: (value) => this.setState({sessionIV_Hiking101: value, isSession_IV: true})
        },
        {
            Title: "Turkey/Waterfowl Hunting 101",
            Details: TurkeyWaterfowlHunting101,
            Instructor: "Luke Naylor/Chris Racey",
            ButtonGroupName: "Session IV Turkey/Waterfowl Hunting 101",
            onChangeCourse: (value) => this.setState({sessionIV_TurkeyWaterfowlHunting101: value, isSession_IV: true})
        },
    ]


    const FormInputList = [
        {
            hintText:"John",
            floatingLabelText:"First Name",
            value: this.state.firstName,
            onChange: (event) => this.setState({firstName: event.target.value}),
            errorText: /^(\s+)$/i.test(this.state.firstName) ? formFieldError : null
        },
        {
            hintText:"Smith",
            floatingLabelText:"Middle Name",
            value: this.state.middleName,
            onChange: (event) => this.setState({middleName: event.target.value}),
            errorText: /^(\s+)$/i.test(this.state.middleName) ? formFieldError : null
        },
        {
            hintText:"Doe",
            floatingLabelText:"Last Name",
            value: this.state.lastName,
            onChange: (event) => this.setState({lastName: event.target.value}),
            errorText: /^(\s+)$/i.test(this.state.lastName) ? formFieldError : null
        },
        {
            hintText:"2 Natural Resources Drive",
            floatingLabelText:"Address 1",
            value: this.state.addressOne,
            onChange: (event) => this.setState({addressOne: event.target.value}),
            errorText: /^(\s+)$/i.test(this.state.addressOne) ? formFieldError : null
        },
        {
            hintText:"PO Box",
            floatingLabelText:"Address 2",
            value: this.state.addressTwo,
            onChange: (event) => this.setState({addressTwo: event.target.value}),
            errorText: /^(\s+)$/i.test(this.state.addressTwo) ? formFieldError : null
        },
        {
            hintText:"Little Rock",
            floatingLabelText:"City",
            value: this.state.city,
            onChange: (event) => this.setState({city: event.target.value}),
            errorText: /^(\s+)$/i.test(this.state.city) ? formFieldError : null
        },
        {
            hintText:"Arkansas",
            floatingLabelText:"State",
            value: this.state.homeState,
            onChange: (event) => this.setState({homeState: event.target.value}),
            errorText: /^(\s+)$/i.test(this.state.homeState) ? formFieldError : null
        },
        {
            hintText:"72223",
            floatingLabelText:"Zip Code",
            value: this.state.zipCode,
            onChange: (event) => this.setState({zipCode: event.target.value}),
            errorText: this.state.zipCode !== undefined && !/^[0-9]+$/i.test(this.state.zipCode) ? 'Numeric Characters Only' : null
        },
        {
            hintText:"501-555-5555",
            floatingLabelText:"Phone (Day)",
            value: this.state.phoneDay,
            onChange: (event) => this.setState({phoneDay: event.target.value}),
            errorText: this.state.phoneDay !== undefined && !/^[1-9]\d{2}-\d{3}-\d{4}$/i.test(this.state.phoneDay) ? 'Enter a valid Phone Number: 501-555-5555' : null
        },
        {
            hintText:"501-222-2222",
            floatingLabelText:"Phone (Night)",
            value: this.state.phoneNight,
            onChange: (event) => this.setState({phoneNight: event.target.value}),
            errorText: this.state.phoneNight !== undefined && !/^[1-9]\d{2}-\d{3}-\d{4}$/i.test(this.state.phoneNight) ? 'Enter a valid Phone Number: 501-222-2222' : null
        },
        {
            hintText:"John@gmail.com",
            floatingLabelText:"Email",
            value: this.state.email,
            onChange: (event) => this.setState({email: event.target.value}),
            errorText: this.state.email !== undefined && !/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(this.state.email) ? 'Enter a valid email address: John@gmail.com' : null
        },
        {
            hintText:"John@gmail.com",
            floatingLabelText:"Confirm Email",
            value: this.state.confirmEmail,
            onChange: (event) => this.setState({confirmEmail: event.target.value}),
            errorText: this.state.confirmEmail !== undefined && !/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(this.state.confirmEmail) ? 'Enter a valid email address: John@gmail.com' : null
        },
    ]

    const roomMateList = [
        {
            hintText:"Amanda",
            floatingLabelText:"First Friend",
            value: this.state.roomMateOne,
            onChange: (event) => this.setState({roomMateOne: event.target.value}),
            errorText: /^(\s+)$/i.test(this.state.roomMateOne) ? formFieldError : null
        },
        {
            hintText:"Mary",
            floatingLabelText:"Second Friend",
            value: this.state.roomMateTwo,
            onChange: (event) => this.setState({roomMateTwo: event.target.value}),
            errorText: /^(\s+)$/i.test(this.state.roomMateTwo) ? formFieldError : null
        },
    ]  

    const SelectFieldList = [
        {
            floatingLabelText:"T-Shirt Size",
            value: this.state.shirtSize,
            onChange: (event,index, value) => this.setState({shirtSize: value}),
            subHeader: <Subheader inset={false}>Select T-Shirt Size</Subheader>,
            items: shirtItems
        },
        {
            floatingLabelText:"Past Work Shops Attended",
            value: this.state.attendedWorkShopCount,
            onChange: (event,index, value) => this.setState({attendedWorkShopCount: value}),
            subHeader: <Subheader inset={false}>Quantity of Work Shops attended?</Subheader>,
            items: workShopItems
        },
    ]

    return (
            <MuiThemeProvider>
                <Fragment>
                    <Header/>
                        <Paper zDepth={5} className="container" style={{marginTop: 10}}>
                            <AppBar
                                title="REGISTRATION FORM"
                                showMenuIconButton={false}
                                style={style.appBar}
                            />
                            <Fragment>
                                        {
                                            FormInputList.map((l, i) =>(
                                                <TextField
                                                    key={i}
                                                    hintText={l.hintText}
                                                    floatingLabelText={l.floatingLabelText}
                                                    value={l.value}
                                                    onChange={l.onChange}
                                                    style={style}
                                                    underlineFocusStyle={style.underlineStyle}
                                                    floatingLabelFocusStyle={style.floatingLabelStyle}
                                                    errorText={l.errorText}
                                                />
                                            ))
                                        }

                                    {
                                        SelectFieldList.map((l, i) =>(
                                            <SelectField
                                            key={i}
                                            value={l.value}
                                            onChange={l.onChange}
                                            floatingLabelText={l.floatingLabelText}
                                            style={style}
                                            selectedMenuItemStyle={style.selectedDropDownItem}
                                        >
                                           {l.subHeader}
                                            {l.items}
                                        </SelectField>
                                        ))
                                    }

                                <Subheader inset={false} style={{fontWeight: 'bold'}}>Roomate Preferences: There is usually 3 women per room. Please list 2 additional friends.</Subheader>

                                     {
                                            roomMateList.map((l, i) =>(
                                                <TextField
                                                    key={i}
                                                    hintText={l.hintText}
                                                    floatingLabelText={l.floatingLabelText}
                                                    value={l.value}
                                                    onChange={l.onChange}
                                                    style={style}
                                                    underlineFocusStyle={style.underlineStyle}
                                                    floatingLabelFocusStyle={style.floatingLabelStyle}
                                                    errorText={l.errorText}
                                                />
                                            ))
                                        }
                                <Subheader inset={false} style={{fontWeight: 'bold'}}>Please list any dietary needs or request:</Subheader>
                                <TextField
                                    hintText="Peanut Allergies"
                                    floatingLabelText="Dietary needs"
                                    value={this.state.dietaryNeeds}
                                    onChange={(event) => this.setState({dietaryNeeds: event.target.value})}
                                    style={style}
                                    underlineFocusStyle={style.underlineStyle}
                                    floatingLabelFocusStyle={style.floatingLabelStyle}
                                    multiLine={true}
                                    rows={5}
                                    errorText={/^(\s+)$/i.test(this.state.dietaryNeeds) ? formFieldError : null}
                                />
                                <br/>
                            </Fragment>
                        </Paper>
                        <Paper zDepth={5} className="container" style={{marginBottom: 10}}>
                            <AppBar
                                title="Class Sessions"
                                showMenuIconButton={false}
                                style={{textAlign: 'center', marginTop: 15, marginBottom: 15, backgroundColor: "#009390"}}

                            />

                            <Subheader inset={false} style={{fontWeight: 'bold'}}>
                                The weekend is divided into four educational sessions:
                                Session I (Friday afternoon),
                                Session II (Saturday morning),
                                Session III (Saturday afternoon), and
                                Session IV (Sunday morning).
                                Rank each class, per session, using a scale 1-5, with 1 being your preferred class and 5 being your least preferred class. You can have more than one class per ranking.
                            </Subheader>
                        
                            {confirmation}
                            {submitError}
                            {formSubmissionSuccess}

                            <Tabs>
                                    <Tab label="Session I" style={{backgroundColor: "#544b7f"}}>
                                        <Table selectable={false} multiSelectable={true}>
                                            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                                <TableRow>
                                                    <TableHeaderColumn colSpan="3" tooltip="Session I Friday, Sept. 28, 1:30 - 5:00" style={{textAlign: 'center', fontWeight:'bold', fontSize:'100%', color:'black'}}>
                                                        Session I Friday, Sept. 28, 1:30 - 5:00
                                                    </TableHeaderColumn>
                                                </TableRow>
                                                <TableRow>
                                                    <TableHeaderColumn tooltip="Avaialable Course for Session I">ClassName</TableHeaderColumn>
                                                    <TableHeaderColumn colSpan="2" tooltip="Select your Course Rankings By selecting a value" style={{textAlign: 'center'}}>Choice Ranking </TableHeaderColumn>
                                                </TableRow>
                                            </TableHeader>
                                            <TableBody displayRowCheckbox={false}>
                                                        {
                                                            SessionICourseList.map((l, i) =>(
                                                                <SessionCourse 
                                                                key={i} 
                                                                availableCourseTitle={l.Title} 
                                                                availableCourseDetails={l.Details}
                                                                availableCourseInstructor={l.Instructor}
                                                                radioButtonGroupName={l.ButtonGroupName}
                                                                onRadioGroupChange={l.onChangeCourse}
                                                                />
                                                            ))
                                                        }
                                            </TableBody>
                                        </Table>
                                    </Tab>
                                    <Tab label="Session II" style={{backgroundColor: "#031560"}}>
                                        <Table selectable={false} multiSelectable={true} >
                                            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                                <TableRow>
                                                    <TableHeaderColumn colSpan="3" tooltip="Session II Saturday, Sept. 29, 8:00 - 11:30"  style={{textAlign: 'center', fontWeight:'bold', fontSize:'100%', color:'black'}}>
                                                        Session II Saturday, Sept. 29, 8:00 - 11:30
                                                    </TableHeaderColumn>
                                                </TableRow>
                                                <TableRow>
                                                    <TableHeaderColumn tooltip="Avaialable Course for Session II">Class Name</TableHeaderColumn>
                                                    <TableHeaderColumn  tooltip="Select your Course Rankings By selecting a value"  colSpan="2"  style={{textAlign: 'center'}} >Choice Ranking</TableHeaderColumn>
                                                </TableRow>
                                            </TableHeader>
                                            <TableBody displayRowCheckbox={false}>                                                                             
                                                            {
                                                                SessionIICourseList.map((l, i) =>(
                                                                    <SessionCourse 
                                                                    key={i} 
                                                                    availableCourseTitle={l.Title} 
                                                                    availableCourseDetails={l.Details}
                                                                    availableCourseInstructor={l.Instructor}
                                                                    radioButtonGroupName={l.ButtonGroupName}
                                                                    onRadioGroupChange={l.onChangeCourse}
                                                                    />
                                                                ))
                                                            }                        
                                            </TableBody>
                                        </Table>
                                    </Tab>
                                    <Tab label="Session III" style={{backgroundColor: "#8277af"}}>
                                        <Table selectable={false} multiSelectable={true}>
                                            <TableHeader displaySelectAll={false} adjustForCheckbox={false} >
                                                <TableRow>
                                                    <TableHeaderColumn colSpan="3" tooltip="Session III Saturday, Sept. 29, 1:30 - 5:00" style={{textAlign: 'center', fontWeight:'bold', fontSize:'100%', color:'black'}}>
                                                        Session III Saturday, Sept. 29, 1:30 - 5:00
                                                    </TableHeaderColumn>
                                                </TableRow>
                                                <TableRow>
                                                    <TableHeaderColumn tooltip="Avaialable Course for Session III">Class Name</TableHeaderColumn>
                                                    <TableHeaderColumn  tooltip="Select your Course Rankings By selecting a value" colSpan="2"  style={{textAlign: 'center'}} >Choice Ranking</TableHeaderColumn>
                                                </TableRow>
                                            </TableHeader>
                                            <TableBody displayRowCheckbox={false}>
                                                            {
                                                                SessionIIICourseList.map((l, i) =>(
                                                                    <SessionCourse 
                                                                    key={i} 
                                                                    availableCourseTitle={l.Title} 
                                                                    availableCourseDetails={l.Details}
                                                                    availableCourseInstructor={l.Instructor}
                                                                    radioButtonGroupName={l.ButtonGroupName}
                                                                    onRadioGroupChange={l.onChangeCourse}
                                                                    />
                                                                ))
                                                            }    
                                            </TableBody>
                                        </Table>
                                    </Tab>
                                    <Tab label="Session IV" style={{backgroundColor: "#403b8e"}}>
                                        <Table selectable={false} multiSelectable={true} >
                                            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                                <TableRow>
                                                    <TableHeaderColumn colSpan="3" tooltip="Session IV Sunday, Sept. 30, 8:00 - 11:30" style={{textAlign: 'center', fontWeight:'bold', fontSize:'100%', color:'black'}}>
                                                        Session IV Sunday, Sept. 30, 8:00 - 11:30
                                                    </TableHeaderColumn>
                                                </TableRow>
                                                <TableRow>
                                                    <TableHeaderColumn tooltip="Avaialable Course for Session IV">Class Name</TableHeaderColumn>
                                                    <TableHeaderColumn    tooltip="Select your Course Rankings By selecting a value" colSpan="2"  style={{textAlign: 'center'}} >Choice Ranking</TableHeaderColumn>
                                                </TableRow>
                                            </TableHeader>
                                            <TableBody displayRowCheckbox={false}>
                                                            {
                                                                SessionIVCourseList.map((l, i) =>(
                                                                    <SessionCourse 
                                                                    key={i} 
                                                                    availableCourseTitle={l.Title} 
                                                                    availableCourseDetails={l.Details}
                                                                    availableCourseInstructor={l.Instructor}
                                                                    radioButtonGroupName={l.ButtonGroupName}
                                                                    onRadioGroupChange={l.onChangeCourse}
                                                                    />
                                                                ))
                                                            }    
                                            </TableBody>
                                        </Table>
                                    </Tab>
                            </Tabs>
                            <div style={{overflow: "auto"}}>
                                <FloatingActionButton style={{margin: 10, float: "right"}} onClick={this.handleOpen} backgroundColor="#009390" disabled={errors ? true : false}>
                                    <ContentSave/>
                                </FloatingActionButton>
                                <Snackbar open={errors ? true : false} message={errors} autoHideDuration={4000} onRequestClose={this.handleSnackerClose}contentStyle={{color: '#FF6700', textAlign: 'center', fontSize:'125%'}}/>
                            </div>
                        </Paper>
                </Fragment>
            </MuiThemeProvider>
        );
    }
}

export default RegistrationForm


// WEBPACK FOOTER //
// ./src/components/RegistrationForm.jsx